import { Company } from '@/api/model/company'
import { BaseModel } from '@/api/base-model'
import { BranchAPI } from '@/api/backend-client'
import { AcceptedReferralTypes, AssignedZipcodes, BranchType, ReferralType } from '@/api/types'
import { Pipeline } from '@/api/model/pipeline'

export class Branch extends BaseModel<Branch> {
    protected collectionName = BranchAPI.collectionName

    constructor(
        public company: Company|null,
        public pipelines: Pipeline[],
        public id: string,
        public name: string,
        public displayName: string|null,
        public type: BranchType,
        public streetname: string|null,
        public streetnumber: string|null,
        public suffix: string|null,
        public zipcode: string|null,
        public city: string|null,
        public country: string|null,
        public phonenumber: string|null,
        public email: string|null,
        public website: string|null,
        public logo: string|null,
        public primaryColor: string|null,
        public acceptedReferralTypes: AcceptedReferralTypes,
        public assignedZipcodes: AssignedZipcodes,
        public notifyOnReferralCreatedEmailList: [],
        public notifyOnSmartMarketingReferralCreatedEmailList: [],
        public createdAt: Date,
        public updatedAt: Date,
    ) { super(id) }

    /**
     * Returns true if branch accepts specified referral type. False if not.
     * @param referralType
     */
    acceptsReferralType(referralType: string|ReferralType): boolean {
        if (typeof this.acceptedReferralTypes[referralType] === 'undefined') {
            return false
        }

        return this.acceptedReferralTypes[referralType]
    }

    static fromData(data: any): Branch {
        if (data === null || typeof data === 'string' || data instanceof Branch) {
            return data
        }

        return new Branch(
            data.company ? Company.fromData(data.company) : null,
            data.pipelines ? data.pipelines.map(pipeline => Pipeline.fromData(pipeline)) : [],
            data.id,
            data.name,
            data.displayName,
            data.type,
            data.streetname,
            data.streetnumber,
            data.suffix,
            data.zipcode,
            data.city,
            data.country,
            data.phonenumber,
            data.email,
            data.website,
            data.logo,
            data.primaryColor,
            data.acceptedReferralTypes ? (data.acceptedReferralTypes instanceof Array ? {} : data.acceptedReferralTypes) : {},
            data.assignedZipcodes ? (data.assignedZipcodes instanceof Array ? {} : data.assignedZipcodes) : {},
            data.notifyOnReferralCreatedEmailList ?? [],
            data.notifyOnSmartMarketingReferralCreatedEmailList ?? [],
            data.createdAt,
            data.updatedAt,
        )
    }
}
